exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".filter-panel .number-filter-view.is-empty .value {\n  color: #808080;\n}\n", ""]);
